module.exports = __webpack_public_path__ + "img/delete-table.2979131b.svg";